var LineType = /* @__PURE__ */ ((LineType2) => {
  LineType2["SOLID"] = "solid";
  LineType2["DOTTED"] = "dotted";
  LineType2["DASHED"] = "dashed";
  return LineType2;
})(LineType || {});
var ArrowType = /* @__PURE__ */ ((ArrowType2) => {
  ArrowType2["NONE"] = "none";
  ArrowType2["BOTH"] = "both";
  ArrowType2["BOTH_START"] = "bothStart";
  ArrowType2["DIAMOND"] = "diamond";
  ArrowType2["DIAMOND_START"] = "diamondStart";
  ArrowType2["DIAMOND_FILLED"] = "diamondFilled";
  ArrowType2["DIAMOND_FILLED_START"] = "diamondFilledStart";
  ArrowType2["TOP"] = "top";
  ArrowType2["TOP_START"] = "topStart";
  ArrowType2["BOTTOM"] = "bottom";
  ArrowType2["BOTTOM_START"] = "bottomStart";
  ArrowType2["BOTH_FILLED"] = "bothFilled";
  ArrowType2["BOTH_FILLED_START"] = "bothFilledStart";
  ArrowType2["BOTH_OUTLINED"] = "bothOutlined";
  ArrowType2["BOTH_OUTLINED_START"] = "bothOutlinedStart";
  ArrowType2["CIRCLE"] = "circle";
  ArrowType2["CIRCLE_START"] = "circleStart";
  ArrowType2["ONE"] = "one";
  ArrowType2["ONE_START"] = "oneStart";
  ArrowType2["ONE_MANDATORY"] = "oneMandatory";
  ArrowType2["ONE_MANDATORY_START"] = "oneMandatoryStart";
  ArrowType2["MANY"] = "many";
  ArrowType2["MANY_START"] = "manyStart";
  ArrowType2["ONE_OR_MANY"] = "oneOrMany";
  ArrowType2["ONE_OR_MANY_START"] = "oneOrManyStart";
  ArrowType2["ZERO_OR_ONE"] = "zeroOrOne";
  ArrowType2["ZERO_OR_ONE_START"] = "zeroOrOneStart";
  ArrowType2["ZERO_OR_MANY"] = "zeroOrMany";
  ArrowType2["ZERO_OR_MANY_START"] = "zeroOrManyStart";
  ArrowType2["DEFAULT"] = "default";
  ArrowType2["DEFAULT_START"] = "defaultStart";
  return ArrowType2;
})(ArrowType || {});
var LoginOptions = /* @__PURE__ */ ((LoginOptions2) => {
  LoginOptions2["PLAIN"] = "plain";
  LoginOptions2["GITHUB"] = "github";
  LoginOptions2["LIVE_CONNECT"] = "live-connect";
  LoginOptions2["GOOGLE"] = "google";
  LoginOptions2["OKTA"] = "okta";
  LoginOptions2["SAFEWHERE"] = "safewhere";
  LoginOptions2["PING"] = "ping";
  LoginOptions2["NETIQ"] = "netiq";
  LoginOptions2["ACTIVE_DIRECTORY"] = "active-directory";
  LoginOptions2["ACTIVE_DIRECTORY_STAGING"] = "active-directory-staging";
  LoginOptions2["ACTIVE_DIRECTORY_GAMMA"] = "active-directory-gamma";
  LoginOptions2["NET_IQ"] = "netiq";
  LoginOptions2["OPEN_AM"] = "openam";
  LoginOptions2["ADFS"] = "adfs";
  LoginOptions2["ILEX"] = "ilex";
  LoginOptions2["ONELOGIN"] = "onelogin";
  LoginOptions2["SAML"] = "saml";
  LoginOptions2["SAML_ADFS"] = "samladfs";
  LoginOptions2["SAML_OKTA"] = "samlokta";
  LoginOptions2["SHIBBOLETH"] = "shibboleth";
  LoginOptions2["MICROSOFTONLINE"] = "microsoftonline";
  LoginOptions2["OAUTH2"] = "oauth2";
  LoginOptions2["OIC"] = "oic";
  return LoginOptions2;
})(LoginOptions || {});
var AssetType = /* @__PURE__ */ ((AssetType2) => {
  AssetType2["TRAVERSAL"] = "traversal";
  AssetType2["FOLDER"] = "workspacefolder";
  AssetType2["WORKSPACE"] = "workspace";
  AssetType2["PRESENTATION"] = "presentation";
  AssetType2["SURVEY"] = "survey";
  AssetType2["METAMODEL"] = "metamodel";
  AssetType2["SCENARIO"] = "scenario";
  AssetType2["REPORT"] = "report";
  AssetType2["DASHBOARD"] = "dashboard";
  AssetType2["BROADCAST"] = "broadcast";
  AssetType2["VIEWPOINT"] = "viewpoint";
  AssetType2["BOOKMARK"] = "bookmark";
  return AssetType2;
})(AssetType || {});
var ResourceType = /* @__PURE__ */ ((ResourceType2) => {
  ResourceType2["COMPONENT"] = "component";
  ResourceType2["WORKSPACE"] = "workspace";
  ResourceType2["WORKSPACEFOLDER"] = "workspacefolder";
  ResourceType2["FIELD"] = "field";
  ResourceType2["MODEL"] = "model";
  ResourceType2["REFERENCE"] = "reference";
  ResourceType2["TAG"] = "tag";
  ResourceType2["SURVEY"] = "survey";
  ResourceType2["DASHBOARD"] = "dashboard";
  ResourceType2["SCENARIO"] = "scenario";
  ResourceType2["PERMISSION"] = "permission";
  ResourceType2["REPORT"] = "report";
  ResourceType2["VIEWPOINT"] = "viewpoint";
  ResourceType2["BROADCAST"] = "broadcast";
  ResourceType2["PERMISSION_ZONE"] = "permission-zone";
  ResourceType2["TRAVERSAL"] = "traversal";
  ResourceType2["CHAT"] = "chat";
  ResourceType2["PRESENTATION"] = "presentation";
  ResourceType2["SLIDE"] = "slide";
  ResourceType2["METAMODEL"] = "metamodel";
  ResourceType2["BOOKMARK"] = "bookmark";
  return ResourceType2;
})(ResourceType || {});
var OrgAccessLevel = /* @__PURE__ */ ((OrgAccessLevel2) => {
  OrgAccessLevel2["ADMIN"] = "admin";
  OrgAccessLevel2["WRITER"] = "writer";
  OrgAccessLevel2["READER"] = "reader";
  OrgAccessLevel2["CONTRIBUTOR"] = "contributor";
  return OrgAccessLevel2;
})(OrgAccessLevel || {});
var PermissionAccessLevel = /* @__PURE__ */ ((PermissionAccessLevel2) => {
  PermissionAccessLevel2["ADMIN"] = "admin";
  PermissionAccessLevel2["EDIT"] = "edit";
  PermissionAccessLevel2["READ"] = "read";
  return PermissionAccessLevel2;
})(PermissionAccessLevel || {});
var SurveyPermissionAccessLevel = /* @__PURE__ */ ((SurveyPermissionAccessLevel2) => {
  SurveyPermissionAccessLevel2["CONTRIBUTE"] = "contribute";
  return SurveyPermissionAccessLevel2;
})(SurveyPermissionAccessLevel || {});
var UserManagementSettings = /* @__PURE__ */ ((UserManagementSettings2) => {
  UserManagementSettings2["IN_APP_ONLY"] = "in-app-only";
  UserManagementSettings2["IN_APP_AND_EXTERNALLY"] = "in-app-and-externally";
  UserManagementSettings2["EXTERNALLY"] = "externally";
  return UserManagementSettings2;
})(UserManagementSettings || {});
var OrganizationKeys = /* @__PURE__ */ ((OrganizationKeys2) => {
  OrganizationKeys2["CUSTOM_DOMAIN"] = "custom-domain";
  OrganizationKeys2["ACTIVE_DIRECTORY"] = "active-directory-settings";
  OrganizationKeys2["IS_TRIAL"] = "is-trial";
  OrganizationKeys2["DAYS_REMAINING_TRIAL"] = "days-remaining-trial";
  OrganizationKeys2["NAME"] = "name";
  OrganizationKeys2["FEATURES"] = "features";
  OrganizationKeys2["SETTINGS"] = "settings";
  OrganizationKeys2["HAS_CONSENTED_TO_VIEW_DATA"] = "hasConsentedToViewData";
  return OrganizationKeys2;
})(OrganizationKeys || {});
var CustomDomainKeys = /* @__PURE__ */ ((CustomDomainKeys2) => {
  CustomDomainKeys2["BASE_URL"] = "base-url";
  CustomDomainKeys2["LOGIN_OPTIONS"] = "login-options";
  CustomDomainKeys2["USER_MANAGEMENT"] = "user-management";
  CustomDomainKeys2["DEFAULT_ROLE"] = "default-role";
  return CustomDomainKeys2;
})(CustomDomainKeys || {});
var ViewIds = /* @__PURE__ */ ((ViewIds2) => {
  ViewIds2["BLOCK_DIAGRAM"] = "blockDiagram";
  ViewIds2["BUBBLE"] = "bubble";
  ViewIds2["CAPABILITY_MAP"] = "capabilityMap";
  ViewIds2["CIRCULAR_RELATIONSHIP_DIAGRAM"] = "explorer";
  ViewIds2["COMPONENTTREE"] = "componenttree";
  ViewIds2["DEPMATRIX"] = "depmatrix";
  ViewIds2["DEPWHEEL"] = "depwheel";
  ViewIds2["REFERENCETABLE"] = "referenceTable";
  ViewIds2["ROADMAP"] = "roadmap";
  ViewIds2["SPIDER"] = "spider";
  ViewIds2["SWIMLANE"] = "swimlane";
  ViewIds2["TABLEVIEW"] = "tableview";
  ViewIds2["TAGSCAPE"] = "tagscape";
  ViewIds2["TIMELINE"] = "timeline";
  ViewIds2["TREEMAP"] = "treemap";
  ViewIds2["PAGESVIEW"] = "pagesView";
  ViewIds2["COMPONENT_MATRIX"] = "componentMatrix";
  ViewIds2["DEPENDENCY_MAP_2"] = "dependencyMap";
  ViewIds2["NETWORK"] = "relationships2";
  ViewIds2["RELATIONSHIPS_3"] = "relationships3";
  ViewIds2["ISOMETRIC_BLOCK_DIAGRAM"] = "isometricBlockDiagram";
  ViewIds2["NONE"] = "";
  ViewIds2["SIMPLE_BLOCK_DIAGRAM"] = "simpleBlockDiagram";
  ViewIds2["PROTEAN_DIAGRAM"] = "proteanDiagram";
  ViewIds2["HIERARCHICAL_TREEMAP"] = "hierarchicalTreemap";
  ViewIds2["HIERARCHICAL_PACKING"] = "hierarchicalPacking";
  ViewIds2["SUNBURST"] = "sunburst";
  ViewIds2["METAMODEL"] = "metamodel";
  ViewIds2["BLOCKS"] = "blocks";
  ViewIds2["SEQUENCE"] = "sequence";
  ViewIds2["REFERENCE_AGGREGATION_VIEW"] = "referenceAggregationView";
  ViewIds2["PROCESSFLOW"] = "processflow";
  ViewIds2["HEATMAP"] = "heatmap";
  ViewIds2["API_DOCUMENTATION"] = "apiDocumentation";
  ViewIds2["RELATIONSHIPS"] = "relationships";
  ViewIds2["DEPMAP"] = "depmap";
  ViewIds2["MODERNIZED_BLOCK_DIAGRAM"] = "modernizedBlockDiagram";
  return ViewIds2;
})(ViewIds || {});
var HTTPStatusCode = /* @__PURE__ */ ((HTTPStatusCode2) => {
  HTTPStatusCode2[HTTPStatusCode2["CONTINUE"] = 100] = "CONTINUE";
  HTTPStatusCode2[HTTPStatusCode2["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
  HTTPStatusCode2[HTTPStatusCode2["OK"] = 200] = "OK";
  HTTPStatusCode2[HTTPStatusCode2["CREATED"] = 201] = "CREATED";
  HTTPStatusCode2[HTTPStatusCode2["ACCEPTED"] = 202] = "ACCEPTED";
  HTTPStatusCode2[HTTPStatusCode2["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
  HTTPStatusCode2[HTTPStatusCode2["NO_CONTENT"] = 204] = "NO_CONTENT";
  HTTPStatusCode2[HTTPStatusCode2["RESET_CONTENT"] = 205] = "RESET_CONTENT";
  HTTPStatusCode2[HTTPStatusCode2["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
  HTTPStatusCode2[HTTPStatusCode2["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
  HTTPStatusCode2[HTTPStatusCode2["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
  HTTPStatusCode2[HTTPStatusCode2["FOUND"] = 302] = "FOUND";
  HTTPStatusCode2[HTTPStatusCode2["SEE_OTHER"] = 303] = "SEE_OTHER";
  HTTPStatusCode2[HTTPStatusCode2["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
  HTTPStatusCode2[HTTPStatusCode2["USE_PROXY"] = 305] = "USE_PROXY";
  HTTPStatusCode2[HTTPStatusCode2["TEMPORARY REDIRECT"] = 307] = "TEMPORARY REDIRECT";
  HTTPStatusCode2[HTTPStatusCode2["BAD_REQUEST"] = 400] = "BAD_REQUEST";
  HTTPStatusCode2[HTTPStatusCode2["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
  HTTPStatusCode2[HTTPStatusCode2["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
  HTTPStatusCode2[HTTPStatusCode2["FORBIDDEN"] = 403] = "FORBIDDEN";
  HTTPStatusCode2[HTTPStatusCode2["NOT_FOUND"] = 404] = "NOT_FOUND";
  HTTPStatusCode2[HTTPStatusCode2["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
  HTTPStatusCode2[HTTPStatusCode2["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
  HTTPStatusCode2[HTTPStatusCode2["PROXY_AUTHENTICATION REQUIRED"] = 407] = "PROXY_AUTHENTICATION REQUIRED";
  HTTPStatusCode2[HTTPStatusCode2["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
  HTTPStatusCode2[HTTPStatusCode2["CONFLICT"] = 409] = "CONFLICT";
  HTTPStatusCode2[HTTPStatusCode2["GONE"] = 410] = "GONE";
  HTTPStatusCode2[HTTPStatusCode2["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
  HTTPStatusCode2[HTTPStatusCode2["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
  HTTPStatusCode2[HTTPStatusCode2["REQUEST_ENTITY_TOO_LARGE"] = 413] = "REQUEST_ENTITY_TOO_LARGE";
  HTTPStatusCode2[HTTPStatusCode2["REQUEST-URI_TOO_LONG"] = 414] = "REQUEST-URI_TOO_LONG";
  HTTPStatusCode2[HTTPStatusCode2["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
  HTTPStatusCode2[HTTPStatusCode2["REQUESTED_RANGE_NOT_SATISFIABLE"] = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE";
  HTTPStatusCode2[HTTPStatusCode2["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
  HTTPStatusCode2[HTTPStatusCode2["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
  HTTPStatusCode2[HTTPStatusCode2["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
  HTTPStatusCode2[HTTPStatusCode2["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
  HTTPStatusCode2[HTTPStatusCode2["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
  HTTPStatusCode2[HTTPStatusCode2["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
  HTTPStatusCode2[HTTPStatusCode2["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
  HTTPStatusCode2[HTTPStatusCode2["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
  HTTPStatusCode2[HTTPStatusCode2["UNKNOWN_ERROR"] = 520] = "UNKNOWN_ERROR";
  return HTTPStatusCode2;
})(HTTPStatusCode || {});
var APIEntityType = /* @__PURE__ */ ((APIEntityType2) => {
  APIEntityType2["COMPONENT"] = "component";
  APIEntityType2["FIELD"] = "field";
  APIEntityType2["MODEL"] = "model";
  APIEntityType2["PERMISSION"] = "permission";
  APIEntityType2["REFERENCE"] = "reference";
  APIEntityType2["TAG"] = "tag";
  APIEntityType2["WORKSPACE"] = "workspace";
  APIEntityType2["COMPONENT_TYPE"] = "component-type";
  APIEntityType2["REFERENCE_TYPE"] = "reference-type";
  APIEntityType2["ATTACHMENT"] = "attachment";
  APIEntityType2["WORKSPACE_FOLDER"] = "workspacefolder";
  APIEntityType2["DOCUMENT_ARCHIVE_FOLDER"] = "folder";
  APIEntityType2["DASHBOARD"] = "dashboard";
  APIEntityType2["REPORT"] = "report";
  APIEntityType2["PERMISSION_ZONE"] = "permission-zone";
  APIEntityType2["SUBDIVISION"] = "subdivision";
  APIEntityType2["TRAVERSAL"] = "traversal";
  APIEntityType2["SLIDE"] = "slide";
  APIEntityType2["PRESENTATION"] = "presentation";
  APIEntityType2["CHANGE_REQUEST"] = "change-request";
  APIEntityType2["SCENARIO"] = "scenario";
  APIEntityType2["CALL_TO_ACTION"] = "call-to-action";
  APIEntityType2["GROUP"] = "group";
  return APIEntityType2;
})(APIEntityType || {});
var PrivilegeLabel = /* @__PURE__ */ ((PrivilegeLabel2) => {
  PrivilegeLabel2["ACCESS_DISCOVER"] = "access-discover";
  PrivilegeLabel2["CONFIGURE_PRIVILEGES"] = "configure-privileges";
  PrivilegeLabel2["CREATE_SCENARIO"] = "create-scenario";
  PrivilegeLabel2["CREATE_SURVEY"] = "create-survey";
  PrivilegeLabel2["CREATE_DASHBOARD"] = "create-dashboard";
  PrivilegeLabel2["CREATE_REPORT"] = "create-report";
  PrivilegeLabel2["GLOBAL_DATA_ACCESS"] = "global-data-access";
  PrivilegeLabel2["CREATE_VIEWPOINT"] = "create-viewpoint";
  PrivilegeLabel2["CREATE_WORKSPACE"] = "create-workspace";
  PrivilegeLabel2["CREATE_GREMLIN_QUERIES"] = "create-gremlin";
  PrivilegeLabel2["READ_GROUPS"] = "read-groups";
  PrivilegeLabel2["MANAGE_GROUPS"] = "manage-groups";
  PrivilegeLabel2["CREATE_API_TOKEN"] = "create-api-token";
  return PrivilegeLabel2;
})(PrivilegeLabel || {});
var MagicReferenceTypes = /* @__PURE__ */ ((MagicReferenceTypes2) => {
  MagicReferenceTypes2[MagicReferenceTypes2["syntheticParentChild"] = -1] = "syntheticParentChild";
  MagicReferenceTypes2[MagicReferenceTypes2["implicit"] = 2] = "implicit";
  return MagicReferenceTypes2;
})(MagicReferenceTypes || {});
var ScopeDataCollection = /* @__PURE__ */ ((ScopeDataCollection2) => {
  ScopeDataCollection2["COMPONENTS"] = "components";
  ScopeDataCollection2["FIELDS"] = "fields";
  ScopeDataCollection2["MODELS"] = "models";
  ScopeDataCollection2["PERMISSIONS"] = "permissions";
  ScopeDataCollection2["REFERENCES"] = "references";
  ScopeDataCollection2["TAGS"] = "tags";
  return ScopeDataCollection2;
})(ScopeDataCollection || {});
var APIFieldType = /* @__PURE__ */ ((APIFieldType2) => {
  APIFieldType2["CHECKBOX"] = "Checkbox";
  APIFieldType2["DATE_ONLY"] = "Date";
  APIFieldType2["DATE_ONLY_RANGE"] = "DateOnlyRange";
  APIFieldType2["DATE_TIME"] = "DateTime";
  APIFieldType2["DATE_TIME_RANGE"] = "DateTimeRange";
  APIFieldType2["EMAIL"] = "Email";
  APIFieldType2["FILE"] = "File";
  APIFieldType2["LIST"] = "List";
  APIFieldType2["NUMBER"] = "Number";
  APIFieldType2["SELECT_MULTIPLE_LIST"] = "SelectMultipleList";
  APIFieldType2["TEXT"] = "Text";
  APIFieldType2["TEXT_AREA"] = "TextArea";
  APIFieldType2["URL"] = "Url";
  APIFieldType2["USER"] = "User";
  return APIFieldType2;
})(APIFieldType || {});
var Verb = /* @__PURE__ */ ((Verb2) => {
  Verb2["DELETE"] = "delete";
  Verb2["CREATE"] = "create";
  Verb2["UPDATE"] = "update";
  Verb2["MERGE"] = "merge";
  return Verb2;
})(Verb || {});
var ReferenceDirection = /* @__PURE__ */ ((ReferenceDirection2) => {
  ReferenceDirection2["UNSET"] = "unset";
  ReferenceDirection2["OUTGOING"] = "outgoing";
  ReferenceDirection2["INCOMING"] = "incoming";
  ReferenceDirection2["NONE"] = "none";
  return ReferenceDirection2;
})(ReferenceDirection || {});
var GroupType = /* @__PURE__ */ ((GroupType2) => {
  GroupType2["PARENT_ALL"] = "PARENT_ALL";
  GroupType2["COMPONENT"] = "COMPONENT";
  GroupType2["WORKSPACE"] = "WORKSPACE";
  GroupType2["REFERENCE"] = "REFERENCE";
  GroupType2["REFERENCE_CONTEXTUAL"] = "REFERENCE_CONTEXTUAL";
  GroupType2["PARENT"] = "PARENT";
  GroupType2["CHILD"] = "CHILD";
  GroupType2["FIELD"] = "FIELD";
  GroupType2["SUBDIVISION"] = "SUBDIVISION";
  GroupType2["TAG"] = "TAG";
  GroupType2["ALL"] = "ALL";
  return GroupType2;
})(GroupType || {});
var BooleanOperator = /* @__PURE__ */ ((BooleanOperator2) => {
  BooleanOperator2["AND"] = "AND";
  BooleanOperator2["OR"] = "OR";
  return BooleanOperator2;
})(BooleanOperator || {});
var UnitOfTime = /* @__PURE__ */ ((UnitOfTime2) => {
  UnitOfTime2["MILLISECOND"] = "ms";
  UnitOfTime2["SECOND"] = "seconds";
  UnitOfTime2["MINUTE"] = "minutes";
  UnitOfTime2["HOUR"] = "hours";
  UnitOfTime2["DAY"] = "days";
  UnitOfTime2["WEEK"] = "weeks";
  UnitOfTime2["MONTH"] = "months";
  UnitOfTime2["QUARTER"] = "quarters";
  UnitOfTime2["YEAR"] = "years";
  return UnitOfTime2;
})(UnitOfTime || {});
var GroupingCollapseState = /* @__PURE__ */ ((GroupingCollapseState2) => {
  GroupingCollapseState2["EXPAND_ALL"] = "expand_all";
  GroupingCollapseState2["COLLAPSE_ALL"] = "collapse_all";
  return GroupingCollapseState2;
})(GroupingCollapseState || {});
var FilterInfoOperator = /* @__PURE__ */ ((FilterInfoOperator2) => {
  FilterInfoOperator2["ID_MATCH"] = "idMatch";
  FilterInfoOperator2["DATE_MATCH"] = "dateMatch";
  FilterInfoOperator2["DATE_EARLIER"] = "dateEarlier";
  FilterInfoOperator2["DATE_LATER"] = "dateLater";
  FilterInfoOperator2["BOOLEAN"] = "boolean";
  FilterInfoOperator2["EQUALS"] = "equals";
  FilterInfoOperator2["LESS_THAN"] = "lessThan";
  FilterInfoOperator2["GREATER_THAN"] = "greaterThan";
  FilterInfoOperator2["CONTAINS"] = "contains";
  FilterInfoOperator2["DATE_RANGE_CONTAINS"] = "dateRangeContains";
  FilterInfoOperator2["DATE_RANGE_DOES_NOT_CONTAIN"] = "dateRangeDoesNotContain";
  FilterInfoOperator2["DATE_RANGE_BEFORE"] = "dateRangeBefore";
  FilterInfoOperator2["DATE_RANGE_AFTER"] = "dateRangeAfter";
  return FilterInfoOperator2;
})(FilterInfoOperator || {});
var DiffMode = /* @__PURE__ */ ((DiffMode2) => {
  DiffMode2["SCENARIO"] = "scenario";
  DiffMode2["DIFF"] = "diff";
  DiffMode2["MAIN"] = "main";
  return DiffMode2;
})(DiffMode || {});
var Operator = /* @__PURE__ */ ((Operator2) => {
  Operator2["CONTAINS"] = "contains";
  Operator2["NOT_CONTAINS"] = "not_contains";
  Operator2["CONTAINS_PHRASE"] = "contains_phrase";
  Operator2["NOT_CONTAINS_PHRASE"] = "not_contains_phrase";
  Operator2["CONTAINS_SUBSTRING"] = "contains_substring";
  Operator2["NOT_CONTAINS_SUBSTRING"] = "not_contains_substring";
  Operator2["IS_EMPTY"] = "is_empty";
  Operator2["IS_NOT_EMPTY"] = "is_not_empty";
  Operator2["GREATER"] = "greater";
  Operator2["GREATER_OR_EQUAL"] = "greater_or_equal";
  Operator2["LESS"] = "less";
  Operator2["LESS_OR_EQUAL"] = "less_or_equal";
  Operator2["BETWEEN"] = "between";
  Operator2["BETWEEN_INCLUSIVE"] = "between_inclusive";
  Operator2["EQUAL"] = "equal";
  Operator2["NOT_EQUAL"] = "not_equal";
  Operator2["CHECKED"] = "checked";
  Operator2["UNCHECKED"] = "unchecked";
  Operator2["UNSET"] = "UNSET";
  Operator2["FROM"] = "from";
  Operator2["TO"] = "to";
  return Operator2;
})(Operator || {});
var SearchBackend = /* @__PURE__ */ ((SearchBackend2) => {
  SearchBackend2["ADVANCED_SEARCH"] = "advanced-search";
  SearchBackend2["GREMLIN"] = "gremlin";
  return SearchBackend2;
})(SearchBackend || {});
var SearchType = /* @__PURE__ */ ((SearchType2) => {
  SearchType2["QUERY"] = "query";
  SearchType2["PARAMETER_QUERY"] = "parameterQuery";
  SearchType2["METAMODEL_QUERY"] = "metamodelQuery";
  SearchType2["DYNAMIC_FILTER_QUERY"] = "dynamicFilterQuery";
  SearchType2["CALCULATED_FIELD_QUERY"] = "calculatedFieldQuery";
  SearchType2["BROADCAST_AUDIENCE_QUERY"] = "broadcastAudienceQuery";
  return SearchType2;
})(SearchType || {});
var SortOrder = /* @__PURE__ */ ((SortOrder2) => {
  SortOrder2["ASC"] = "ASC";
  SortOrder2["DESC"] = "DESC";
  SortOrder2["DEFAULT"] = "DEFAULT";
  return SortOrder2;
})(SortOrder || {});
const allIPAllowlistTypes = ["api", "any"];
var SSOMappingAction = /* @__PURE__ */ ((SSOMappingAction2) => {
  SSOMappingAction2["ADD_TO_GROUP"] = "add-to-group";
  return SSOMappingAction2;
})(SSOMappingAction || {});
var SSOMappingCondition = /* @__PURE__ */ ((SSOMappingCondition2) => {
  SSOMappingCondition2["EMPTY"] = "";
  SSOMappingCondition2["ELEMENT_CONTAINS"] = "element-contains";
  SSOMappingCondition2["ELEMENT_EQUALS"] = "element-equals";
  SSOMappingCondition2["STRING_CONTAINS"] = "string-contains";
  SSOMappingCondition2["STRING_EQUALS"] = "string-equals";
  return SSOMappingCondition2;
})(SSOMappingCondition || {});
var AddToGroupAction = /* @__PURE__ */ ((AddToGroupAction2) => {
  AddToGroupAction2["JOIN"] = "join-groups";
  AddToGroupAction2["LEAVE"] = "leave-groups";
  return AddToGroupAction2;
})(AddToGroupAction || {});
var LoginConfigurationKey = /* @__PURE__ */ ((LoginConfigurationKey2) => {
  LoginConfigurationKey2["IDP_URI"] = "idp-uri";
  LoginConfigurationKey2["IDP_CERT"] = "idp-cert";
  LoginConfigurationKey2["CLIENT_ID"] = "client-id";
  LoginConfigurationKey2["DISCOVERY_URL"] = "well-known-discovery-url";
  LoginConfigurationKey2["TOKEN_URL"] = "access-token-url";
  LoginConfigurationKey2["AUTHORIZATION_URL"] = "authorization-url";
  LoginConfigurationKey2["USER_LOOKUP_URL"] = "user-lookup-url";
  return LoginConfigurationKey2;
})(LoginConfigurationKey || {});
var AuditLogAction = /* @__PURE__ */ ((AuditLogAction2) => {
  AuditLogAction2["CREATE"] = "create";
  AuditLogAction2["UPDATE"] = "update";
  AuditLogAction2["DELETE"] = "delete";
  return AuditLogAction2;
})(AuditLogAction || {});
const auditLogEntityTypesList = [
  APIEntityType.WORKSPACE,
  APIEntityType.COMPONENT,
  APIEntityType.COMPONENT_TYPE,
  APIEntityType.REFERENCE,
  APIEntityType.REFERENCE_TYPE,
  APIEntityType.FIELD
];
var Aggregate = /* @__PURE__ */ ((Aggregate2) => {
  Aggregate2["SUM"] = "sum";
  Aggregate2["COUNT"] = "count";
  Aggregate2["MAX"] = "max";
  Aggregate2["MIN"] = "min";
  Aggregate2["AVERAGE"] = "avg";
  Aggregate2["AVERAGE_SET"] = "avg-set";
  Aggregate2["MEDIAN"] = "median";
  return Aggregate2;
})(Aggregate || {});
var ReportColumnType = /* @__PURE__ */ ((ReportColumnType2) => {
  ReportColumnType2["FIELD"] = "field";
  ReportColumnType2["GREMLIN_PATH"] = "gremlin-path";
  ReportColumnType2["REFERENCE_TYPE_INCOMING"] = "reference-type-incoming";
  ReportColumnType2["REFERENCE_TYPE_OUTGOING"] = "reference-type-outgoing";
  ReportColumnType2["CUSTOM"] = "custom";
  return ReportColumnType2;
})(ReportColumnType || {});
var DataSourceType = /* @__PURE__ */ ((DataSourceType2) => {
  DataSourceType2["ADVANCED_SEARCH"] = "advancedSearchPostgres";
  DataSourceType2["GREMLIN_SEARCH"] = "graphSearch";
  return DataSourceType2;
})(DataSourceType || {});
var EnhancedSearchStrategy = /* @__PURE__ */ ((EnhancedSearchStrategy2) => {
  EnhancedSearchStrategy2["ADVANCED_COMPONENT"] = "advanced-component";
  EnhancedSearchStrategy2["ADVANCED_REFERENCE"] = "advanced-reference";
  EnhancedSearchStrategy2["GREMLIN_REGULAR"] = "gremlin-regular";
  EnhancedSearchStrategy2["GREMLIN_PATH"] = "gremlin-path";
  EnhancedSearchStrategy2["GENERAL_STRUCTURE"] = "general-structure";
  EnhancedSearchStrategy2["SIMPLE_LIST_STRUCTURE"] = "simple-list-structure";
  EnhancedSearchStrategy2["SINGLE_VALUE_STRUCTURE"] = "single-value-structure";
  EnhancedSearchStrategy2["NO_STRATEGY_FOUND"] = "no-strategy-found";
  EnhancedSearchStrategy2["NO_STORED_QUERY_FOUND_NO_STRATEGY_FOUND"] = "no-stored-query-found-no-strategy-found";
  return EnhancedSearchStrategy2;
})(EnhancedSearchStrategy || {});
var APITaskType = /* @__PURE__ */ ((APITaskType2) => {
  APITaskType2["SURVEY_CHANGE_APPROVAL"] = "survey-change-approval";
  APITaskType2["BROADCAST_TASK"] = "broadcast-task";
  return APITaskType2;
})(APITaskType || {});
var APITaskStatus = /* @__PURE__ */ ((APITaskStatus2) => {
  APITaskStatus2["TODO"] = "todo";
  APITaskStatus2["PENDING"] = "pending";
  APITaskStatus2["COMPLETED"] = "completed";
  return APITaskStatus2;
})(APITaskStatus || {});
const arrowTypeValues = new Set(Object.values(ArrowType));
const isArrowType = (type) => arrowTypeValues.has(type);
const isObject = (type) => {
  return type instanceof Object;
};
const isNumber = (type) => typeof type === "number";
const isNull = (candidate) => candidate === null;
const isString = (candidate) => typeof candidate === "string";
const isBoolean = (candidate) => typeof candidate === "boolean";
const isOf = (candidate, type) => "entity-type" in candidate.ardoq && candidate.ardoq["entity-type"] === type || "entityType" in candidate.ardoq && candidate.ardoq.entityType === type;
const isEntity = (candidate) => isObject(candidate) && typeof candidate._id === "string";
const isVersioned = (candidate) => isObject(candidate) && typeof candidate._version === "number";
const isVersionedEntity = (candidate) => isEntity(candidate) && isVersioned(candidate);
const isArdoqEntity = (candidate) => isObject(candidate) && isObject(candidate.ardoq) && isEntity(candidate);
const getEntityType = (candidate) => {
  if (!candidate || !candidate.ardoq) {
    return null;
  }
  if ("entity-type" in candidate.ardoq) {
    return candidate.ardoq["entity-type"];
  }
  if ("entityType" in candidate.ardoq) {
    return candidate.ardoq.entityType;
  }
  return null;
};
const isAttachment = (candidate) => {
  return isArdoqEntity(candidate) && isOf(candidate, APIEntityType.ATTACHMENT);
};
const isComponent = (candidate) => {
  return isArdoqEntity(candidate) && isOf(candidate, APIEntityType.COMPONENT);
};
const isDashboard = (candidate) => {
  return isArdoqEntity(candidate) && isOf(candidate, APIEntityType.DASHBOARD);
};
const isField = (candidate) => {
  return isArdoqEntity(candidate) && isOf(candidate, APIEntityType.FIELD);
};
const isModel = (candidate) => {
  return isArdoqEntity(candidate) && isOf(candidate, APIEntityType.MODEL);
};
const isPresentation = (candidate) => {
  return isArdoqEntity(candidate) && isOf(candidate, APIEntityType.PRESENTATION);
};
const isReference = (candidate) => {
  return isArdoqEntity(candidate) && isOf(candidate, APIEntityType.REFERENCE);
};
const isReport = (candidate) => {
  return isArdoqEntity(candidate) && isOf(candidate, APIEntityType.REPORT);
};
const isSlide = (candidate) => {
  return isArdoqEntity(candidate) && isOf(candidate, APIEntityType.SLIDE);
};
const isTag = (candidate) => {
  return isArdoqEntity(candidate) && isOf(candidate, APIEntityType.TAG);
};
const isTraversal = (candidate) => {
  return isArdoqEntity(candidate) && isOf(candidate, APIEntityType.TRAVERSAL);
};
const isWorkspace = (candidate) => {
  return isArdoqEntity(candidate) && isOf(candidate, APIEntityType.WORKSPACE);
};
const isAdvancedSearch = (datasource) => datasource === DataSourceType.ADVANCED_SEARCH;
const isGremlinSearch = (datasource) => datasource === DataSourceType.GREMLIN_SEARCH;
const isPersistedSurvey = (survey) => {
  return isEntity(survey);
};
const isChangeApprovalTask = (task) => task.type === APITaskType.SURVEY_CHANGE_APPROVAL;
const isBroadcastTask = (task) => task.type === APITaskType.BROADCAST_TASK;
const isNumberInterval = (candidate) => isObject(candidate) && "start" in candidate && "end" in candidate && (isNumber(candidate.start) || isNull(candidate.start)) && (isNumber(candidate.end) || isNull(candidate.end));
const isFilterValue = (candidate) => isString(candidate) || isNumber(candidate) || isBoolean(candidate) || isNumberInterval(candidate) || isNull(candidate);
const isFilterExpression = (candidate) => isObject(candidate) && "value" in candidate && isFilterValue(candidate.value);
const isFilterExpressionWithLabel = (candidate) => isFilterExpression(candidate) && "label" in candidate && isString(candidate.label);
const isFilterExpressionWithLabelArray = (arr) => {
  if (!Array.isArray(arr)) {
    return false;
  }
  if (arr.some((v) => !isFilterExpressionWithLabel(v))) {
    return false;
  }
  return true;
};
const isFilterExpressionArray = (arr) => {
  if (!Array.isArray(arr)) {
    return false;
  }
  if (arr.some((v) => !isFilterExpression(v))) {
    return false;
  }
  return true;
};
var BroadcastStatus = /* @__PURE__ */ ((BroadcastStatus2) => {
  BroadcastStatus2["RUNNING"] = "running";
  BroadcastStatus2["PAUSED"] = "paused";
  BroadcastStatus2["WARNING"] = "warning";
  BroadcastStatus2["DONE"] = "done";
  BroadcastStatus2["UNPUBLISHED"] = "unpublished";
  return BroadcastStatus2;
})(BroadcastStatus || {});
var BroadcastFilterConditionType = /* @__PURE__ */ ((BroadcastFilterConditionType2) => {
  BroadcastFilterConditionType2["SURVEY_COMPLETE"] = "surveyComplete";
  BroadcastFilterConditionType2["SURVEY_INCOMPLETE"] = "surveyIncomplete";
  BroadcastFilterConditionType2["SURVEY_NOT_UPDATED_IN"] = "surveyNotUpdatedIn";
  BroadcastFilterConditionType2["ADVANCED_SEARCH"] = "advancedSearch";
  BroadcastFilterConditionType2["ADVANCED_SEARCH_BY_REFERENCE"] = "advancedSearchByReference";
  return BroadcastFilterConditionType2;
})(BroadcastFilterConditionType || {});
var TimeSinceLastUpdate = /* @__PURE__ */ ((TimeSinceLastUpdate2) => {
  TimeSinceLastUpdate2["ONE_MONTH"] = "1M";
  TimeSinceLastUpdate2["THREE_MONTHS"] = "3M";
  TimeSinceLastUpdate2["SIX_MONTHS"] = "6M";
  TimeSinceLastUpdate2["TWELVE_MONTHS"] = "12M";
  return TimeSinceLastUpdate2;
})(TimeSinceLastUpdate || {});
var BroadcastContentType = /* @__PURE__ */ ((BroadcastContentType2) => {
  BroadcastContentType2["MESSAGE"] = "message";
  BroadcastContentType2["SURVEY"] = "survey";
  BroadcastContentType2["REPORT"] = "report";
  return BroadcastContentType2;
})(BroadcastContentType || {});
var ReportRuleOperator = /* @__PURE__ */ ((ReportRuleOperator2) => {
  ReportRuleOperator2["GREATER"] = "greater";
  ReportRuleOperator2["LESS"] = "less";
  ReportRuleOperator2["EQUAL"] = "equal";
  ReportRuleOperator2["NOT_EQUAL"] = "not_equal";
  return ReportRuleOperator2;
})(ReportRuleOperator || {});
var BroadcastAggregate = /* @__PURE__ */ ((BroadcastAggregate2) => {
  BroadcastAggregate2["SUM"] = "sum";
  BroadcastAggregate2["COUNT"] = "count-all";
  BroadcastAggregate2["COUNT_NOT_SET"] = "count-not-set";
  BroadcastAggregate2["COUNT_SET"] = "count-set";
  BroadcastAggregate2["MAX"] = "max";
  BroadcastAggregate2["MIN"] = "min";
  BroadcastAggregate2["AVERAGE"] = "avg";
  BroadcastAggregate2["AVERAGE_SET"] = "avg-set";
  BroadcastAggregate2["MEDIAN"] = "median";
  return BroadcastAggregate2;
})(BroadcastAggregate || {});
var BroadcastAudienceType = /* @__PURE__ */ ((BroadcastAudienceType2) => {
  BroadcastAudienceType2["PREDEFINED"] = "predefined";
  BroadcastAudienceType2["EMAIL"] = "email";
  BroadcastAudienceType2["GREMLIN"] = "gremlin";
  BroadcastAudienceType2["WORKSPACE"] = "workspace";
  return BroadcastAudienceType2;
})(BroadcastAudienceType || {});
var AudienceStartingPage = /* @__PURE__ */ ((AudienceStartingPage2) => {
  AudienceStartingPage2["PLAIN"] = "plain";
  AudienceStartingPage2["DISCOVER_COMPONENT"] = "discover-component";
  AudienceStartingPage2["DISCOVER_SURVEY"] = "discover-survey";
  AudienceStartingPage2["SURVEY_OVERVIEW"] = "survey-overview";
  AudienceStartingPage2["SURVEY_COMPONENT"] = "survey-component";
  AudienceStartingPage2["REPORT_ARDOQ"] = "report-ardoq";
  AudienceStartingPage2["REPORT_DISCOVER"] = "report-discover";
  AudienceStartingPage2["MY_TASKS"] = "discover-my-tasks";
  return AudienceStartingPage2;
})(AudienceStartingPage || {});
var IntervalType = /* @__PURE__ */ ((IntervalType2) => {
  IntervalType2["HOUR"] = "hour";
  IntervalType2["DAY"] = "day";
  IntervalType2["WEEK"] = "week";
  IntervalType2["MONTH"] = "month";
  IntervalType2["YEAR"] = "year";
  return IntervalType2;
})(IntervalType || {});
var BroadcastScope = /* @__PURE__ */ ((BroadcastScope2) => {
  BroadcastScope2["SOME"] = "some";
  BroadcastScope2["ALL"] = "all";
  return BroadcastScope2;
})(BroadcastScope || {});
var SurveyResultFilteringType = /* @__PURE__ */ ((SurveyResultFilteringType2) => {
  SurveyResultFilteringType2["REFERENCE"] = "reference";
  SurveyResultFilteringType2["HIERARCHY"] = "hierarchy";
  return SurveyResultFilteringType2;
})(SurveyResultFilteringType || {});
var UpdateType = /* @__PURE__ */ ((UpdateType2) => {
  UpdateType2["CREATED"] = "created";
  UpdateType2["UPDATED"] = "updated";
  UpdateType2["DELETED"] = "deleted";
  return UpdateType2;
})(UpdateType || {});
var SurveyQuestionType = /* @__PURE__ */ ((SurveyQuestionType2) => {
  SurveyQuestionType2["ATTRIBUTE"] = "attribute";
  SurveyQuestionType2["FIELD"] = "field";
  SurveyQuestionType2["TEXT"] = "text";
  SurveyQuestionType2["REFERENCE"] = "reference";
  SurveyQuestionType2["HIDDEN_FIELD"] = "hiddenField";
  SurveyQuestionType2["TAG"] = "tag";
  return SurveyQuestionType2;
})(SurveyQuestionType || {});
var QuickAccessLinkType = /* @__PURE__ */ ((QuickAccessLinkType2) => {
  QuickAccessLinkType2["PRESENTATION"] = "presentation";
  QuickAccessLinkType2["DASHBOARD"] = "dashboard";
  QuickAccessLinkType2["REPORT"] = "report";
  QuickAccessLinkType2["EXTERNAL"] = "external";
  QuickAccessLinkType2["ARDOQ_ASSET"] = "ardoq-asset";
  return QuickAccessLinkType2;
})(QuickAccessLinkType || {});
const isZone = (data) => {
  return "typeInfo" in data && "subId" in data && "configuredComponentTypes" in data;
};
var SubdivisionComponentAssignmentsMode = /* @__PURE__ */ ((SubdivisionComponentAssignmentsMode2) => {
  SubdivisionComponentAssignmentsMode2["MANUAL"] = "manual";
  SubdivisionComponentAssignmentsMode2["ADVANCED_SEARCH"] = "search";
  return SubdivisionComponentAssignmentsMode2;
})(SubdivisionComponentAssignmentsMode || {});
const isSubdivisionComponentAssignmentsMode = (data) => {
  return Object.values(SubdivisionComponentAssignmentsMode).includes(data);
};
var WidgetTypes = /* @__PURE__ */ ((WidgetTypes2) => {
  WidgetTypes2["HEADER"] = "header";
  WidgetTypes2["TABLE"] = "table";
  WidgetTypes2["NUMBER"] = "number";
  WidgetTypes2["LINE_CHART"] = "lineChart";
  WidgetTypes2["PIE_CHART"] = "pieChart";
  WidgetTypes2["STACKED_BAR_CHART"] = "stackedBarChart";
  WidgetTypes2["BAR_CHART"] = "barChart";
  return WidgetTypes2;
})(WidgetTypes || {});
var Periods = /* @__PURE__ */ ((Periods2) => {
  Periods2["ONE_MONTH"] = "1m";
  Periods2["THREE_MONTHS"] = "3m";
  Periods2["SIX_MONTHS"] = "6m";
  Periods2["ONE_YEAR"] = "1y";
  Periods2["ALL_TIME"] = "allTime";
  return Periods2;
})(Periods || {});
var WidgetDataSourceTypes = /* @__PURE__ */ ((WidgetDataSourceTypes2) => {
  WidgetDataSourceTypes2["REPORT"] = "report";
  WidgetDataSourceTypes2["SURVEY"] = "survey";
  WidgetDataSourceTypes2["METRICS"] = "metrics";
  return WidgetDataSourceTypes2;
})(WidgetDataSourceTypes || {});
var NumberFormat = /* @__PURE__ */ ((NumberFormat2) => {
  NumberFormat2["FULL"] = "full";
  NumberFormat2["ABBREVIATED"] = "abbreviated";
  return NumberFormat2;
})(NumberFormat || {});
var BarChartColorOptions = /* @__PURE__ */ ((BarChartColorOptions2) => {
  BarChartColorOptions2["SINGLE_COLOR"] = "singleColor";
  BarChartColorOptions2["COLOR_THEME"] = "colorTheme";
  return BarChartColorOptions2;
})(BarChartColorOptions || {});
var ChartOrderOptions = /* @__PURE__ */ ((ChartOrderOptions2) => {
  ChartOrderOptions2["SIZE"] = "size";
  ChartOrderOptions2["LIST_FIELD"] = "listField";
  ChartOrderOptions2["FIELD_VALUE"] = "fieldValue";
  return ChartOrderOptions2;
})(ChartOrderOptions || {});
var NumberWidgetTrendRangeType = /* @__PURE__ */ ((NumberWidgetTrendRangeType2) => {
  NumberWidgetTrendRangeType2["ROLLING"] = "rolling";
  NumberWidgetTrendRangeType2["CALENDAR"] = "calendar";
  NumberWidgetTrendRangeType2["FIXED_START"] = "fixedStart";
  return NumberWidgetTrendRangeType2;
})(NumberWidgetTrendRangeType || {});
var TrendColorScheme = /* @__PURE__ */ ((TrendColorScheme2) => {
  TrendColorScheme2["CLASSIC"] = "classic";
  TrendColorScheme2["INVERSE"] = "inverse";
  return TrendColorScheme2;
})(TrendColorScheme || {});
var TrendResultStatus = /* @__PURE__ */ ((TrendResultStatus2) => {
  TrendResultStatus2["EXACT"] = "exact";
  TrendResultStatus2["APPROXIMATE"] = "approximate";
  TrendResultStatus2["MISSING"] = "missing";
  return TrendResultStatus2;
})(TrendResultStatus || {});
var PresentationReadPermissions = /* @__PURE__ */ ((PresentationReadPermissions2) => {
  PresentationReadPermissions2["ME"] = "me";
  PresentationReadPermissions2["WS"] = "ws";
  PresentationReadPermissions2["CONTRIBUTOR"] = "contributor";
  PresentationReadPermissions2["ALL"] = "all";
  return PresentationReadPermissions2;
})(PresentationReadPermissions || {});
var PresentationWritePermissions = /* @__PURE__ */ ((PresentationWritePermissions2) => {
  PresentationWritePermissions2["ME"] = "me";
  PresentationWritePermissions2["WS"] = "ws";
  return PresentationWritePermissions2;
})(PresentationWritePermissions || {});
var SlideTypes = /* @__PURE__ */ ((SlideTypes2) => {
  SlideTypes2["VISUALIZATION"] = "visualization";
  SlideTypes2["DASHBOARD"] = "dashboard";
  SlideTypes2["REPORT"] = "report";
  SlideTypes2["METAMODEL"] = "metamodel";
  SlideTypes2["LUCID"] = "lucid";
  return SlideTypes2;
})(SlideTypes || {});
const isFullOrgMetamodelSlide = (slide) => slide && "fullOrg" in slide && slide.fullOrg;
const isSpecificMetamodelSlide = (slide) => slide && !isFullOrgMetamodelSlide(slide);
const isDashboardSlide = (attributes) => attributes.type === "dashboard";
const isMetamodelSlide = (attributes) => attributes.type === "metamodel";
const isReportSlide = (attributes) => attributes.type === "report";
const isVisualizationSlide = (attributes) => attributes.type === "visualization";
const isLucidSlide = (attributes) => {
  return attributes.type === "lucid";
};
const isDateColumn = ({ dataType, isDateRangeColumn: isDateRangeColumn2 }) => (dataType === APIFieldType.DATE_TIME || dataType === APIFieldType.DATE_ONLY) && !isDateRangeColumn2;
const isCheckBoxColumn = ({ dataType }) => dataType === APIFieldType.CHECKBOX;
const isDateRangeColumn = ({ isDateRangeColumn: isDateRangeColumn2 }) => isDateRangeColumn2;
const isUserColumn = ({ dataType }) => dataType === APIFieldType.USER;
const isTextAreaColumn = ({ dataType }) => dataType === APIFieldType.TEXT_AREA;
const isNumberColumn = ({ dataType }) => dataType === APIFieldType.NUMBER;
const isNameColumn = ({ key }) => key === "name";
const isParentColumn = ({ key }) => key === "parent";
const isURLColumn = ({ dataType }) => dataType === APIFieldType.URL;
const isEmailColumn = ({ dataType }) => dataType === APIFieldType.EMAIL;
const isReferenceColumn = ({ type }) => type === ReportColumnType.REFERENCE_TYPE_INCOMING || type === ReportColumnType.REFERENCE_TYPE_OUTGOING;
const isListColumn = ({ dataType }) => dataType === APIFieldType.LIST;
const isSelectMultipleListColumn = ({ dataType }) => dataType === APIFieldType.SELECT_MULTIPLE_LIST;
const isTypeColumn = ({ key }) => key === "type" || key === "typeId";
const isWorkspaceColumn = ({ key }) => key === "rootWorkspace";
const isArdoqOID = ({ key }) => key === "_id";
const columnPredicates = {
  isDateColumn,
  isCheckBoxColumn,
  isDateRangeColumn,
  isUserColumn,
  isTextAreaColumn,
  isNumberColumn,
  isNameColumn,
  isParentColumn,
  isReferenceColumn,
  isURLColumn,
  isEmailColumn,
  isListColumn,
  isSelectMultipleListColumn,
  isTypeColumn,
  isWorkspaceColumn,
  isArdoqOID
};
var PermissionType = /* @__PURE__ */ ((PermissionType2) => {
  PermissionType2["GROUP"] = "group";
  PermissionType2["USER"] = "user";
  return PermissionType2;
})(PermissionType || {});
var RequestResourceAccessResolutionOperationType = /* @__PURE__ */ ((RequestResourceAccessResolutionOperationType2) => {
  RequestResourceAccessResolutionOperationType2["SET_USER_PERMISSIONS"] = "set-user-permissions";
  RequestResourceAccessResolutionOperationType2["SET_GROUP_PERMISSIONS"] = "set-group-permissions";
  RequestResourceAccessResolutionOperationType2["DENY_REQUEST"] = "deny-access-request";
  return RequestResourceAccessResolutionOperationType2;
})(RequestResourceAccessResolutionOperationType || {});
var NotificationTypes = /* @__PURE__ */ ((NotificationTypes2) => {
  NotificationTypes2["REQUEST_ACCESS"] = "request-access";
  NotificationTypes2["DUMMY"] = "dummy";
  NotificationTypes2["SURVEY_CHANGE_APPROVAL"] = "survey-change-approval";
  NotificationTypes2["BROADCAST_TASK"] = "broadcast-task";
  return NotificationTypes2;
})(NotificationTypes || {});
const isRequestAccessNotification = (notification) => notification.details.type === "request-access";
const isChangeApprovalNotification = (notification) => notification.details.type === "survey-change-approval";
const isBroadcastTaskNotification = (notification) => notification.details.type === "broadcast-task";
const isDummyNotification = (notification) => notification.details.type === "dummy";
var UseCaseConfigIds = /* @__PURE__ */ ((UseCaseConfigIds2) => {
  UseCaseConfigIds2["ApplicationLifecycleManagement"] = "ApplicationLifecycleManagement";
  UseCaseConfigIds2["ApplicationIntegrationManagement"] = "ApplicationIntegrationManagement";
  UseCaseConfigIds2["ApplicationHosting"] = "ApplicationHosting";
  UseCaseConfigIds2["BusinessCapabilityModeling"] = "BusinessCapabilityModeling";
  UseCaseConfigIds2["BusinessCapabilityRealization"] = "BusinessCapabilityRealization";
  UseCaseConfigIds2["ITLifecycleManagement"] = "ITLifecycleManagement";
  UseCaseConfigIds2["TechnicalCapabilityManagementRealization"] = "TechnicalCapabilityManagementRealization";
  UseCaseConfigIds2["ITCostManagement"] = "ITCostManagement";
  UseCaseConfigIds2["ApplicationRationalization"] = "ApplicationRationalization";
  UseCaseConfigIds2["DataLineage"] = "DataLineage";
  UseCaseConfigIds2["CloudMigration"] = "CloudMigration";
  UseCaseConfigIds2["StrategyToExecution"] = "StrategyToExecution";
  UseCaseConfigIds2["TechnologyPortfolioManagement"] = "TechnologyPortfolioManagement";
  UseCaseConfigIds2["ApplicationRiskManagement"] = "ApplicationRiskManagement";
  return UseCaseConfigIds2;
})(UseCaseConfigIds || {});
var UseCaseStatus = /* @__PURE__ */ ((UseCaseStatus2) => {
  UseCaseStatus2["IN_PROGRESS"] = "inProgress";
  UseCaseStatus2["PENDING"] = "pending";
  return UseCaseStatus2;
})(UseCaseStatus || {});
var UseCaseAssetType = /* @__PURE__ */ ((UseCaseAssetType2) => {
  UseCaseAssetType2["SERVICENOW_CONFIG"] = "servicenowConfig";
  UseCaseAssetType2["TABULAR_MAPPING"] = "tabularMapping";
  UseCaseAssetType2["PERSPECTIVE"] = "perspective";
  return UseCaseAssetType2;
})(UseCaseAssetType || {});
var ScheduleType = /* @__PURE__ */ ((ScheduleType2) => {
  ScheduleType2["ARDOQ_IMPORT"] = "ardoq-import";
  ScheduleType2["ARDOQ_REFERENCE_DATA_IMPORT"] = "ardoq-reference-data-import";
  ScheduleType2["ARDOQ_SAMPLE_DATA_IMPORT"] = "ardoq-sample-data-import";
  ScheduleType2["SHAREPOINT_FILES_IMPORT"] = "sharepoint-files-import";
  ScheduleType2["SERVICENOW_IMPORT"] = "servicenow-import";
  ScheduleType2["SERVICENOW_EXPORT"] = "servicenow-export";
  ScheduleType2["ITPEDIA_ENRICHMENT"] = "itpedia-enrichment";
  ScheduleType2["CLOUD_IMPORT"] = "cloud-provider-import";
  ScheduleType2["JIRA_IMPORT"] = "jira-software-import";
  ScheduleType2["SIGNAVIO_IMPORT"] = "signavio-import";
  ScheduleType2["SIGNAVIO_EXPORT"] = "signavio-export";
  ScheduleType2["CELONIS_IMPORT"] = "celonis-import";
  ScheduleType2["SYMBIO_IMPORT"] = "symbio-import";
  ScheduleType2["MICROSOFT_ENTRA_ID_IMPORT"] = "microsoftgraph-import";
  return ScheduleType2;
})(ScheduleType || {});
var SearchContext = /* @__PURE__ */ ((SearchContext2) => {
  SearchContext2["COMPONENT"] = "component";
  SearchContext2["REFERENCE"] = "reference";
  SearchContext2["WORKSPACE"] = "workspace";
  return SearchContext2;
})(SearchContext || {});
const isQueryBuilderRule = (rule) => "field" in rule;
const isQueryBuilderSubquery = (rule) => "condition" in rule;
var AdvancedSearchResultType = /* @__PURE__ */ ((AdvancedSearchResultType2) => {
  AdvancedSearchResultType2["COMPONENT"] = "component";
  AdvancedSearchResultType2["REFERENCE"] = "reference";
  AdvancedSearchResultType2["WORKSPACE"] = "workspace";
  return AdvancedSearchResultType2;
})(AdvancedSearchResultType || {});
var SearchBy = /* @__PURE__ */ ((SearchBy2) => {
  SearchBy2["NAME_DESCRIPTION"] = "nameOrDescription";
  SearchBy2["FIELD_VALUE"] = "fieldValue";
  return SearchBy2;
})(SearchBy || {});
var PersonalSetting = /* @__PURE__ */ ((PersonalSetting2) => {
  PersonalSetting2["DEFAULT"] = "default";
  PersonalSetting2["LOCALE"] = "locale";
  PersonalSetting2["ORGANIZATION"] = "organization";
  PersonalSetting2["ENFORCE_FILTERS_DIALOG"] = "enforceFiltersDialogUserSettingKey";
  PersonalSetting2["FAVORITE_TEMPLATES"] = "favoriteTemplates";
  PersonalSetting2["FAVORITE"] = "favorite";
  PersonalSetting2["LAST_USED_REFERENCE_TYPE_NAME"] = "lastUsedReferenceTypeName";
  PersonalSetting2["LAST_USED_REFERENCE_TYPE_NAME_TRIPLES"] = "lastUsedReferenceTypeNameTriples";
  PersonalSetting2["SHOWN_EMAIL_PREFERENCES"] = "shownEmailPreferences";
  PersonalSetting2["DISABLE_REFERENCE_TIPS"] = "disableReferenceTip";
  PersonalSetting2["HIDE_MODEL_PREVIEW"] = "hideModelPreview";
  PersonalSetting2["LAST_VIEWED_DASHBOARD"] = "lastViewedDashboard";
  PersonalSetting2["HIDE_ON_CLOSE_SCENARIO_WARNING"] = "hideOnCloseScenarioWarningDialog";
  PersonalSetting2["QUICK_PERSPECTIVES_CONTAINER_EXPANDED"] = "quickPerspectivesContainerExpanded";
  PersonalSetting2["HAS_SEEN_SSO_ATTRIBUTE_MAPPING"] = "hasSeenSsoAttributeMapping";
  PersonalSetting2["HIDE_LWUI_NAVIGATION_TIPS_MODAL"] = "hideLWUINavigationTipsModal";
  PersonalSetting2["USER_VISITED_DISCOVER"] = "userVisitedDiscover";
  PersonalSetting2["DISCOVER_SIDEBAR_WIDTH"] = "discoverSidebarWidth";
  PersonalSetting2["HAS_SEEN_USAGE_METRICS_DASHBOARD"] = "hasSeenUsageMetricsDashboard";
  PersonalSetting2["HAS_SEEN_AUDIT_LOG"] = "hasSeenAuditLog";
  PersonalSetting2["USE_SEMANTIC_SEARCH"] = "useSemanticSearch";
  PersonalSetting2["INCLUDE_CLICK_OTHER_COMPONENT_TYPE_NODES_HINTS_IN_VIEWPOINT_BUILDER"] = "includeClickOtherComponentTypeNodesHintsInViewpointBuilder";
  PersonalSetting2["DONT_SHOW_REMOVE_DATASET_CONFIRMATION"] = "dontShowRemoveDatasetConfirmation";
  PersonalSetting2["DONT_SHOW_CLOSE_VIEW_BUILDER_CONFIRMATION"] = "dontShowCloseViewBuilderConfirmation";
  PersonalSetting2["HIDE_UPDATED_REPORT_BUILDER_NOTIFICATION"] = "hideUpdatedReportBuilderNotification";
  PersonalSetting2["HIDE_REPORT_BUILDER_COLUMN_RENAME_NOTIFICATION"] = "hideReportBuilderColumnRenameNotification";
  PersonalSetting2["USE_CASE_UPDATES_SEEN"] = "useCaseUpdatesSeen";
  PersonalSetting2["DONT_SHOW_OPEN_DATASET_CONFIRMATION"] = "dontShowOpenNewDatasetConfirmation";
  PersonalSetting2["DONT_SHOW_OPEN_WORKSPACE_CONFIRMATION"] = "dontShowOpenWorkspaceConfirmation";
  PersonalSetting2["ASSETS_BROWSER_PER_PAGE"] = "assetsBrowserPerPage";
  PersonalSetting2["GENERIC_SHOW_FILTERED_COMPONENTS"] = "generic_showFilteredComponents";
  PersonalSetting2["HOMEPAGE_VIEWPOINTS_STATE"] = "homepageViewpointsState";
  PersonalSetting2["EPHERMERAL_NOTIFICATION_SETTINGS_KEY"] = "ephemeralDismissedBanners";
  PersonalSetting2["INVENTORY_RECENT_COLUMN_SELECTION_PER_WORKSPACE_OR_TYPE"] = "inventoryRecentColumnSelectionPerWorkspaceOrType";
  PersonalSetting2["USER_ASSETS_OVERVIEW_TAB_VISITED"] = "userAssetsOverviewVisited";
  PersonalSetting2["PRESENTATION_OVERVIEW_STATE"] = "presentationOverviewState";
  return PersonalSetting2;
})(PersonalSetting || {});
var FilterTypes = /* @__PURE__ */ ((FilterTypes2) => {
  FilterTypes2["ATTRIBUTE"] = "attribute";
  FilterTypes2["TAG"] = "tag";
  FilterTypes2["DATE_RANGE"] = "date_range";
  FilterTypes2["REFERENCE_LABEL"] = "refLabel";
  FilterTypes2["COMPONENT_LABEL"] = "compLabel";
  return FilterTypes2;
})(FilterTypes || {});
const hasColor = (attributes) => {
  return Boolean(attributes.color);
};
const hasRulesAndCondition = (attributes) => {
  const { rules, condition } = attributes;
  return Array.isArray(rules) && Boolean(condition);
};
const isType = (attributes, type) => {
  return attributes.type === type;
};
const affectsComponent = (attributes) => {
  return Boolean(attributes.affectComponent);
};
const affectsReference = (attributes) => {
  return Boolean(attributes.affectReference);
};
const isComponentFilter = (attributes) => !hasColor(attributes) && affectsComponent(attributes) && !isType(
  attributes,
  "compLabel"
  /* COMPONENT_LABEL */
);
const isReferenceFilter = (attributes) => !hasColor(attributes) && affectsReference(attributes) && !isType(
  attributes,
  "refLabel"
  /* REFERENCE_LABEL */
);
const isFormatting = (attributes) => hasColor(attributes) || isType(
  attributes,
  "refLabel"
  /* REFERENCE_LABEL */
) || isType(
  attributes,
  "compLabel"
  /* COMPONENT_LABEL */
);
const isConditionalFormatting = (attributes) => hasColor(attributes) && !isType(
  attributes,
  "refLabel"
  /* REFERENCE_LABEL */
) && !isType(
  attributes,
  "compLabel"
  /* COMPONENT_LABEL */
);
const isComponentConditionalFormatting = (attributes) => isConditionalFormatting(attributes) && affectsComponent(attributes) && isType(
  attributes,
  "attribute"
  /* ATTRIBUTE */
);
const isReferenceConditionalFormatting = (attributes) => isConditionalFormatting(attributes) && affectsReference(attributes) && isType(
  attributes,
  "attribute"
  /* ATTRIBUTE */
);
const isTagConditionalFormatting = (attributes) => hasColor(attributes) && isType(
  attributes,
  "tag"
  /* TAG */
);
const isReferenceLabelFormatting = (attributes) => isType(
  attributes,
  "refLabel"
  /* REFERENCE_LABEL */
);
const isComponentLabelFormatting = (attributes) => isType(
  attributes,
  "compLabel"
  /* COMPONENT_LABEL */
);
const filterAttributesIsSubquery = (filter) => {
  return hasRulesAndCondition(filter);
};
const isWorkspaceFilter = (attributes) => {
  var _a;
  if (!hasRulesAndCondition(attributes)) return false;
  return Boolean(
    (_a = attributes.rules) == null ? void 0 : _a.every((rule) => rule.name === "rootWorkspace")
  );
};
var TraversalPathMatchingType = /* @__PURE__ */ ((TraversalPathMatchingType2) => {
  TraversalPathMatchingType2["LOOSE"] = "loose";
  TraversalPathMatchingType2["STRICT"] = "strict";
  TraversalPathMatchingType2["SUPERSTRICT"] = "superstrict";
  return TraversalPathMatchingType2;
})(TraversalPathMatchingType || {});
var StartContextSelectionType = /* @__PURE__ */ ((StartContextSelectionType2) => {
  StartContextSelectionType2[StartContextSelectionType2["MANUAL_SELECTION"] = 1] = "MANUAL_SELECTION";
  StartContextSelectionType2[StartContextSelectionType2["BASIC_SEARCH_SELECT_ALL"] = 2] = "BASIC_SEARCH_SELECT_ALL";
  StartContextSelectionType2[StartContextSelectionType2["ADVANCED_SEARCH_SELECT_ALL"] = 3] = "ADVANCED_SEARCH_SELECT_ALL";
  return StartContextSelectionType2;
})(StartContextSelectionType || {});
const isManualComponentSelection = (componentSelection) => {
  return componentSelection.startContextSelectionType === 1;
};
const isQueryComponentSelection = (componentSelection) => {
  return componentSelection.startContextSelectionType === 2 || componentSelection.startContextSelectionType === 3;
};
const isStartSetTraversal = (traversal) => isManualComponentSelection(traversal.componentSelection);
const isStartQueryTraversal = (traversal) => isQueryComponentSelection(traversal.componentSelection);
var LoadedStateType = /* @__PURE__ */ ((LoadedStateType2) => {
  LoadedStateType2["SEARCH"] = "search";
  LoadedStateType2["TRAVERSAL"] = "traversal";
  LoadedStateType2["CREATED_ITEMS"] = "createdItems";
  LoadedStateType2["TRAVERSAL_CREATED_IN_VIEW"] = "traversalCreatedInView";
  return LoadedStateType2;
})(LoadedStateType || {});
const isSearchLoadedState = (state) => state.type === "search";
const isCreatedItemsLoadedState = (state) => state.type === "createdItems";
const isTraversalLoadedState = (state) => state.type === "traversal";
const isAnyTraversalLoadedState = (state) => state.type === "traversal" || state.type === "traversalCreatedInView";
const isTraversalCreatedInViewLoadedState = (state) => state.type === "traversalCreatedInView";
const hasLoadedState = (loadedStates) => loadedStates.some(
  (loadedState) => isSearchLoadedState(loadedState) || isTraversalLoadedState(loadedState) || isCreatedItemsLoadedState(loadedState) || isTraversalCreatedInViewLoadedState(loadedState)
);
var CalculatedTransformationOperation = /* @__PURE__ */ ((CalculatedTransformationOperation2) => {
  CalculatedTransformationOperation2["GREMLIN"] = "gremlin";
  return CalculatedTransformationOperation2;
})(CalculatedTransformationOperation || {});
var ExternalDocumentProvider = /* @__PURE__ */ ((ExternalDocumentProvider2) => {
  ExternalDocumentProvider2["LUCIDCHART"] = "lucidchart";
  return ExternalDocumentProvider2;
})(ExternalDocumentProvider || {});
var LocallyDerivedTransformationOperation = /* @__PURE__ */ ((LocallyDerivedTransformationOperation2) => {
  LocallyDerivedTransformationOperation2["DICTIONARY_LOOKUP"] = "dictionary_lookup";
  LocallyDerivedTransformationOperation2["MATH"] = "team_core_math";
  LocallyDerivedTransformationOperation2["CONCAT"] = "concat";
  return LocallyDerivedTransformationOperation2;
})(LocallyDerivedTransformationOperation || {});
const IMAGE_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/tiff",
  "image/webp",
  "image/bmp"
];
const SVG_MIME_TYPES = ["image/svg+xml"];
const supportedMimeTypes = [...IMAGE_MIME_TYPES, ...SVG_MIME_TYPES];
const isSupportedMimeType = (mimeType) => new Set(supportedMimeTypes).has(mimeType);
const isSupportedSvgMimeType = (mimeType) => new Set(SVG_MIME_TYPES).has(mimeType);
const isSupportedImageMimeType = (mimeType) => new Set(IMAGE_MIME_TYPES).has(mimeType);
const extractMimeType = (contentType) => {
  const mimeTypeMatch = contentType.match(/^\s*([^;]+)\s*(?:;|$)/i);
  return mimeTypeMatch ? mimeTypeMatch[1].toLowerCase() : "";
};
const isContentTypeSupportedByImagePreview = (file) => isSupportedMimeType(extractMimeType(file["content-type"] ?? ""));
var ImageContentType = /* @__PURE__ */ ((ImageContentType2) => {
  ImageContentType2["IMAGE"] = "image";
  ImageContentType2["SVG"] = "svg";
  return ImageContentType2;
})(ImageContentType || {});
export {
  APIEntityType,
  APIFieldType,
  APITaskStatus,
  APITaskType,
  AddToGroupAction,
  AdvancedSearchResultType,
  Aggregate,
  ArrowType,
  AssetType,
  AudienceStartingPage,
  AuditLogAction,
  BarChartColorOptions,
  BooleanOperator,
  BroadcastAggregate,
  BroadcastAudienceType,
  BroadcastContentType,
  BroadcastFilterConditionType,
  BroadcastScope,
  BroadcastStatus,
  CalculatedTransformationOperation,
  ChartOrderOptions,
  CustomDomainKeys,
  DataSourceType,
  DiffMode,
  EnhancedSearchStrategy,
  ExternalDocumentProvider,
  FilterInfoOperator,
  FilterTypes,
  GroupType,
  GroupingCollapseState,
  HTTPStatusCode,
  ImageContentType,
  IntervalType,
  LineType,
  LoadedStateType,
  LocallyDerivedTransformationOperation,
  LoginConfigurationKey,
  LoginOptions,
  MagicReferenceTypes,
  NotificationTypes,
  NumberFormat,
  NumberWidgetTrendRangeType,
  Operator,
  OrgAccessLevel,
  OrganizationKeys,
  Periods,
  PermissionAccessLevel,
  PermissionType,
  PersonalSetting,
  PresentationReadPermissions,
  PresentationWritePermissions,
  PrivilegeLabel,
  QuickAccessLinkType,
  ReferenceDirection,
  ReportColumnType,
  ReportRuleOperator,
  RequestResourceAccessResolutionOperationType,
  ResourceType,
  SSOMappingAction,
  SSOMappingCondition,
  ScheduleType,
  ScopeDataCollection,
  SearchBackend,
  SearchBy,
  SearchContext,
  SearchType,
  SlideTypes,
  SortOrder,
  StartContextSelectionType,
  SubdivisionComponentAssignmentsMode,
  SurveyPermissionAccessLevel,
  SurveyQuestionType,
  SurveyResultFilteringType,
  TimeSinceLastUpdate,
  TraversalPathMatchingType,
  TrendColorScheme,
  TrendResultStatus,
  UnitOfTime,
  UpdateType,
  UseCaseAssetType,
  UseCaseConfigIds,
  UseCaseStatus,
  UserManagementSettings,
  Verb,
  ViewIds,
  WidgetDataSourceTypes,
  WidgetTypes,
  allIPAllowlistTypes,
  auditLogEntityTypesList,
  columnPredicates,
  extractMimeType,
  filterAttributesIsSubquery,
  getEntityType,
  hasLoadedState,
  isAdvancedSearch,
  isAnyTraversalLoadedState,
  isArrowType,
  isAttachment,
  isBroadcastTask,
  isBroadcastTaskNotification,
  isChangeApprovalNotification,
  isChangeApprovalTask,
  isComponent,
  isComponentConditionalFormatting,
  isComponentFilter,
  isComponentLabelFormatting,
  isConditionalFormatting,
  isContentTypeSupportedByImagePreview,
  isCreatedItemsLoadedState,
  isDashboard,
  isDashboardSlide,
  isDummyNotification,
  isEntity,
  isField,
  isFilterExpression,
  isFilterExpressionArray,
  isFilterExpressionWithLabel,
  isFilterExpressionWithLabelArray,
  isFilterValue,
  isFormatting,
  isFullOrgMetamodelSlide,
  isGremlinSearch,
  isLucidSlide,
  isManualComponentSelection,
  isMetamodelSlide,
  isModel,
  isNumber,
  isNumberInterval,
  isObject,
  isPersistedSurvey,
  isPresentation,
  isQueryBuilderRule,
  isQueryBuilderSubquery,
  isQueryComponentSelection,
  isReference,
  isReferenceConditionalFormatting,
  isReferenceFilter,
  isReferenceLabelFormatting,
  isReport,
  isReportSlide,
  isRequestAccessNotification,
  isSearchLoadedState,
  isSlide,
  isSpecificMetamodelSlide,
  isStartQueryTraversal,
  isStartSetTraversal,
  isSubdivisionComponentAssignmentsMode,
  isSupportedImageMimeType,
  isSupportedMimeType,
  isSupportedSvgMimeType,
  isTag,
  isTagConditionalFormatting,
  isTraversal,
  isTraversalCreatedInViewLoadedState,
  isTraversalLoadedState,
  isVersioned,
  isVersionedEntity,
  isVisualizationSlide,
  isWorkspace,
  isWorkspaceFilter,
  isZone
};
//# sourceMappingURL=index.js.map
